(function () {
    let checkoutBtn = document.querySelector('.checkout-btn');
    if (checkoutBtn && checkoutBtn != null) {
        checkoutBtn.addEventListener('click', (e) => {
            checkoutBtn.querySelector('svg').classList.remove('hidden')
            setTimeout(() => {
                checkoutBtn.querySelector('svg').classList.add('hidden')

            }, 1500);
        })
    }
    
    let cartItemQtyInputs = document.querySelectorAll('.cart-drawer__item-quantity');

    cartItemQtyInputs.forEach(input => {
        input.addEventListener('change', (event) => {
            event.target.closest('.cart-drawer__item').classList.add('updating')
            let value = parseInt(event.target.value, 10);
            if (event.target.hasAttribute('data-multiple-qty')) {
                console.log("Multiple")
                if (value % 5 !== 0) {
                    value = Math.ceil(value / 5) * 5;
                }
                
            }
          
            event.target.value = value;
            console.log(event.target.value)


            let line = event.target.closest('.cart-drawer__item').dataset.line
            let prodData = {
                quantity: event.target.value,
                line: line
            };
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(prodData)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data)
                    document.dispatchEvent(new CustomEvent('HP::CartBuild'))
                });
        });
    });

    window.removeItem = function(button, lineIndex, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            },
            body: JSON.stringify({
            line: lineIndex,
            quantity: quantity
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
            document.dispatchEvent(new CustomEvent('HP::CartBuild')) 

        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
    document.addEventListener('HP::CartBuild', e => {
        fetch(window.location.href)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(
                    responseText,
                    "text/html"
                );
                console.log(html)
                document.querySelector('#cart-drawer').innerHTML = html.querySelector('#cart-drawer').innerHTML
            })
            .then(() => {
                let cartItemQtyInputs = document.querySelectorAll('.cart-drawer__item-quantity');

                cartItemQtyInputs.forEach(input => {
                    input.addEventListener('change', (event) => {
                        event.target.closest('.cart-drawer__item').classList.add('updating')

                        let value = parseInt(event.target.value, 10);
                        if (event.target.hasAttribute('data-multiple-qty')) {
                            console.log("Multiple")
                            if (value % 5 !== 0) {
                                value = Math.ceil(value / 5) * 5;
                            }
                            
                        }
                    
                        event.target.value = value;
                        console.log(event.target.value)

                        let line = event.target.closest('.cart-drawer__item').dataset.line
                        let prodData = {
                            quantity: event.target.value,
                            line: line
                        };
                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(prodData)
                        })
                            .then(response => {
                                return response.json();
                            })
                            .then(data => {
                                console.log(data)
                                document.dispatchEvent(new CustomEvent('HP::CartBuild'))
                            });
                    });
                });
            })
            .catch((error) => {
                console.error('Error:', error);

            });


    })

})();


